// import Swal from 'sweetalert2';

/*
 * 鎖定 input 類型
 */
const input_lock = {
    number: function ( val, callback ) {
        var self = this;
        var pnumber = val,
            regex = /^[0-9-#]+$/,
            str = '';
        if ( pnumber == '' ) return;
        if ( !regex.test( pnumber ) ) {
            alert( '此欄位限輸入數字。' );
            // Swal.fire('此欄位限輸入數字。');
            for ( var i in pnumber ) {
                if ( regex.test( pnumber[ i ] ) ) str += pnumber[ i ];
            }
            setTimeout( function () {
                callback( str );
            }, 0 );

        }
    },
};


/*
 * 檢查中文
 */
const type_zh = function ( name ) {
    var regExp = /^[\u4e00-\u9fa5\s]+$/;
    if ( name.match( regExp ) && name != ' ' && name != '' ) return true;
    else return false;
};

const personal_id = function ( id ) {
    var id = id.toUpperCase();
    var strTab = "ABCDEFGHJKLMNPQRSTUVWXYZIO";
    var A1 = new Array( 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 3, 3, 3, 3, 3, 3 );
    var A2 = new Array( 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 2, 0, 1, 3, 4, 5 );
    var Mx = new Array( 9, 8, 7, 6, 5, 4, 3, 2, 1, 1 );
    if ( !id.match( /^[a-z][12][\d]{8}$/i ) ) return false;
    var i = strTab.indexOf( id.charAt( 0 ) );
    if ( i == -1 ) return false;
    var sum = A1[ i ] + A2[ i ] * 9;
    for ( i = 1; i < 10; i++ ) {
        var v = parseInt( id.charAt( i ) );
        if ( isNaN( v ) ) return false;
        sum = sum + v * Mx[ i ];
    }
    if ( sum % 10 != 0 ) return false;
    return true;
};


const mobile_phone = function ( phone ) {
    var regExp_1 = "^[09]{2}[0-9]{2}[0-9]{6}$",
        regExp_2 = "^[09]{2}[0-9]{2}-[0-9]{6}$",
        regExp_3 = "^[09]{2}[0-9]{2}-[0-9]{3}-[0-9]{3}$";

    if ( phone.match( regExp_1 ) || phone.match( regExp_2 ) || phone.match( regExp_3 ) ) return true;
    // if (phone.match(regExp_3)) return true;
    else return false;
};


const empty = function ( val ) {
    if ( !val || val == '' || val === undefined || val == NaN ) return false;
    else return true;
};

const email = function ( emailtoCheck ) {
    var regExp = /^[^@^\s]+@[^\.@^\s]+(\.[^\.@^\s]+)+$/;
    if ( emailtoCheck.match( regExp ) ) return true;
    else return false;
};

const specialCharacter = function ( str ) {
    var regExp = /[`~!@#$%^&*()_+<>?:"{},.\/;'[\]]/im;
    if ( !regExp.test( str ) && str.trim() !== '' ) return true;
    else return false;
};


export default {
    input_lock: input_lock,
    type_zh: type_zh,
    personal_id: personal_id,
    mobile_phone: mobile_phone,
    empty: empty,
    email: email,
    specialCharacter: specialCharacter
};